import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { BOLOCR, BolOcrAuditService } from '../bol-ocr-audit.service';

@Component({
  selector: 'lohi-bol-ocr-audit',
  templateUrl: './bol-ocr-audit.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BolOcrAuditComponent implements OnInit {
  public bolocrs$: Observable<BOLOCR[]>;
  public page = 0;
  public numPerPage = 25;

  private updateBolocrSource: () => void;

  constructor(private activatedRoute: ActivatedRoute, private bolocrService: BolOcrAuditService) {
    this.bolocrService.setPage(this.page);
  }

  public ngOnInit(): void {
    this.activatedRoute.data.pipe(take(1)).subscribe((data) => {
      this.setBOLList(data);
    });
  }

  public nextPage(): void {
    this.page++;
    this.bolocrService.setPage(this.page);
    this.updateBolocrSource();
  }

  public prevPage(): void {
    if (this.page === 0) {
      return;
    }
    this.page--;
    this.bolocrService.setPage(this.page);
    this.updateBolocrSource();
  }

  private setBOLList(data: Data) {
    if (data.bolList === 'all') {
      this.bolocrs$ = this.bolocrService.getAllBOLOCRs$();
      this.updateBolocrSource = () => this.bolocrService.getAllBOLOCRs$();
    } else {
      this.bolocrs$ = this.bolocrService.getFailedBOLOCRs$();
      this.updateBolocrSource = () => this.bolocrService.getFailedBOLOCRs$();
    }
  }
}
